import { RoomSelectionBox } from 'components/room-selection-box'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { IRoomSelectionListProps } from './room-selection-list-props.interface'
import './room-selection-list.scss'

const RoomSelectionList: React.FC<IRoomSelectionListProps> = ({ rooms, numDays, dateFrom, dateTo, onChangeRoomSelection }) => {
  const { t } = useTranslation()

  return (
    <div className="edisu-room-selection-list">
      <p className="edisu-text-big">{t('choose_your_room')}</p>
      <div className="list-cnt">
        {rooms.map((r) => {
          return (
            <RoomSelectionBox
              key={r.id}
              room={r}
              numDays={numDays}
              dateFrom={dateFrom}
              dateTo={dateTo}
              totalForRoom={r.prezzo}
              onChangeRoomSelection={(value) => onChangeRoomSelection(r, value)}
            />
          )
        })}
      </div>
    </div>
  )
}

export default RoomSelectionList
